<template>
  <div id="app" :class="$route.meta.ifHomePage? 'bacKK' : 'bac'">
    <router-view/>
  </div>
</template>
<script>
  import { selectUserById } from '@/api'
  // @ is an alias to /src
  export default {
    name: "App",
    data() {
      return {
        ajax_data: {
          search: {
            user_id: 0
          }
        }
      }
    },
    mounted() {
//      console.log(this.$route.query.aid,'this.$route.query.aid',this.$route)
      // const id = this.getGetParams('aid');
      // const paramValue = this.getParamValue('aid');
      // // console.log('GET参数id的值为：', paramValue);
      // // console.log(this.$route.query.aid)
      // if (paramValue != undefined) {
      //   this.ajax_data.search.user_id = paramValue
      //   selectUserById(this.ajax_data).then((res) => {
      //     this.$store.commit('setUserInfo',res.result[0])
      //   })
      // }
    },
    created () {
      //  console.log(this.$route.query.aid,'this.$route.query.aid',this.$route)
      // if (this.$route.query.aid != undefined) {
      //   this.ajax_data.search.user_id = this.$route.query.aid
      //   selectUserById(this.ajax_data).then((res) => {
      //     console.log(res);
      //   });
      // }
      // selectUserById(this.ajax_data).then((res) => {
      //   this.$store.commit('setUserInfo',res.result[0])
      //   console.log(res.result[0]);
      // })
      //在页面加载时读取sessionStorage里的状态信息
      if (sessionStorage.getItem("store") ) {
        this.$store.replaceState(Object.assign({}, this.$store.state,JSON.parse(sessionStorage.getItem("store"))));
        sessionStorage.removeItem('store');
        // this.$router.replace('/')
      }

      //在页面刷新时将vuex里的信息保存到sessionStorage里
      window.addEventListener("beforeunload",()=>{
        sessionStorage.setItem("store",JSON.stringify(this.$store.state))
      })
      if (window.localStorage.getItem('access_token')) {
        this.$store.commit('setToken',window.localStorage.getItem('access_token'))
      }
    },
    methods: {
      // getParamValue(paramName) {
      //   // console.log(window.location.href)
      //   const url = window.location.href;
      //   const paramIndex = url.indexOf(paramName + '=');
      //   if (paramIndex === -1) {
      //       return '';
      //   }
      //   // console.log(paramIndex)
      //   let valueIndex = url.indexOf('=', paramIndex) + 1;
      //   console.log(valueIndex)
      //   // const ampIndex = url.indexOf('&', valueIndex);
      //   // console.log(url.length)
      //   // if (ampIndex === -1) {
      //   //     ampIndex = url.length;
      //   // }
      //   const paramValue = url.substring(valueIndex);
      //   // console.log(paramValue)
      //   return decodeURIComponent(paramValue.replace(/\+/g, ' '));
      // }
    },
  };
</script>
<style lang="scss">
#app {
  // font-family: 'Avenir', Helvetica, Arial, sans-serif;
  font-family: "Open Sans", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  // overflow-y: hidden;
  // .el-card {
  //   border: 1px solid #ddd;
  // }
  // .el-card__header {
  //   font-size: 16px;
  //   background: -webkit-gradient(linear, left top, left bottom, color-stop(0%,#FAFAFA), color-stop(100%,#E9E9E9));
  //   border-bottom: 1px solid #ddd;
  //   padding: 7px 15px;
  //   height: 40px;
  //   line-height: 28px;
  // }
  // .el-card__body {
  //   padding: 0px 15px;
  // }
  // 表格中 thead 背景色
  .el-table thead {
    // color: #24292e;
    color: #4c4f56;
    th {
      background: #f5f7fa;
    }
  }
  .mt10 {
    margin-top: 10px;
  }
  .mt20 {
    margin-top: 20px;
  }
  .mt50 {
    margin-top: 50px;
  }
  .textLeft {
    text-align: left;
  }
  .floatRight {
    float: right;
  }
  .mb10 {
    margin-bottom: 10px;
  }
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
.contable {
  text-align: left;
  .tablecard {
    border: 1px solid #30d0c1;
  }
}
.el-rate {
  margin-top: 10px;
}
.el-input.is-disabled .el-input__inner {
  color: #666666;
}
.el-textarea.is-disabled .el-textarea__inner {
  color: #666666;
}
.el-form-item__content {
  line-height: 20px;
}
.lableline {
  line-height: 40px;
}
// .el-form-item {
//   margin-bottom: 10px;
// }

element.style {
}

div {
    display: block;
}
.el-textarea.is-disabled .el-textarea__inner {
  font-family: inherit;
}
</style>
